import React from 'react';
import { connect } from 'react-redux';
import IndexLink from '../partials/IndexLink';
import { dismissGdprNotice } from '../../actions/user';
import {
  gdprNoticeVisibleSelector,
  messagesSelector,
  userDataSelector
} from '../../helpers/selectors';
import { getMessage as t } from '../../utils/utils';

export function GdprDocumentsNotice({ visible, member, m, onDismiss }) {
  if (!visible) return null;

  const { identityDocumentRequired, drivingLicenceRequired } = member.company || {};

  return (
    <div className="gdpr-documents-notice" role="status">
      <div className="gdpr-documents-notice-body">
        <p className="gdpr-documents-notice-text">
          {t(m, 'profile.gdpr.documents.deleted.info')}
        </p>
        <div className="gdpr-documents-notice-links">
          {identityDocumentRequired && (
            <IndexLink to="/profile/identity-document">
              {t(m, 'label.identity_card')}
            </IndexLink>
          )}
          {drivingLicenceRequired && (
            <IndexLink to="/profile/driver-license">
              {t(m, 'label.driving_licence')}
            </IndexLink>
          )}
        </div>
      </div>
      <button
        type="button"
        className="gdpr-documents-notice-close"
        aria-label={t(m, 'label.close')}
        onClick={() => onDismiss(member.id)}
      >
        &times;
      </button>
    </div>
  );
}

const mapStateToProps = (state) => ({
  visible: gdprNoticeVisibleSelector(state),
  member: userDataSelector(state),
  m: messagesSelector(state)
});

export default connect(mapStateToProps, { onDismiss: dismissGdprNotice })(
  GdprDocumentsNotice
);
